// AD-2639: what a document's row says about SIMS. Empty while it has not been sent.
export const simsStatus = (document) => {
    if (document?.inSims) {
        return 'In SIMS';
    }

    if (document?.sentToSimsAt) {
        return 'Sent to SIMS';
    }

    return '';
};
